import { gql } from "@apollo/client";
export default gql`
  mutation AddUser($input: UserInput!) {
    addUser(input: $input) {
      error
      message
    }
  }
`;
